import React from 'react'

export default function NewComponentWidget({
    onUserInput,
    onUserInputComplete,
    defaultValues,
    component
}) {
  return (
    <div>Please select a component Type</div>
  )
}
